<template>
     <div class="govgr-width-container">
      <div class="govgr-main-wrapper">
         <main class="govgr-grid-column-two-thirds">
            <h1 class="govgr-heading-xl">Είσοδος Υπαλλήλων ΔΟΑΤΑΠ</h1>
            <p class="govgr-body">Για να συνεχίσετε πρέπει να συνδεθείτε.</p>
            <button class="govgr-btn govgr-btn-primary govgr-btn-cta" @click="employEntry()">
              Σύνδεση
              <svg viewBox="0 0 24 24" class="govgr-arrow--right" focusable="false" aria-hidden="true"> <path d="M8.5,2L6.1,4.3l7.6,7.7l-7.6,7.6L8.5,22l10-10L8.5,2z"/> </svg>
            </button>
         </main>
      </div>
   </div>
    <!-- <el-carousel :interval="4000" type="card" height="200px">
      <el-carousel-item v-for="image in images" :key="image">
        <h3>{{ image }}</h3>
      </el-carousel-item>
    </el-carousel>
    <div style="text-align: center">
      <el-button size="mini" type="danger"  round @click="employEntry()">Είσοδος Υπαλλήλων ΔΟΑΤΑΠ</el-button>
    </div> -->
    <!-- <e2e-test></e2e-test> -->
</template>

<script>
import E2eTest from './common/E2eTest'
import router from '../router/index'

export default {
  name: 'Welcome',
  data () {
    return {
      images: ['Welcome to Your Vue.js App', 'fdevcf', 'wefcw']
    }
  },
  components: {
    E2eTest
  },
  methods: {
    employEntry () {
      router.replace('/login')
    }
  },
  computed: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
</style>



// WEBPACK FOOTER //
// src/components/Welcome.vue